import * as ACTION_TYPES from '../types';

let initialState = {
    inventoryList: [],
    inventoryItem: {},
    deviceCatalog: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.GET_INVENTORY_ITEMS:
            return { ...state, inventoryList: action.data };

        case ACTION_TYPES.DELETE_INVENTORY_ITEM:
            return {
                ...state,
                inventoryList: state.inventoryList.filter(item => item._id !== action.id),
            };

        case ACTION_TYPES.GET_INVENTORY_ITEM_BY_ID:
            return { ...state, inventoryItem: action.data };

        case ACTION_TYPES.REQUEST:
            return { ...state, loading: true };

        case ACTION_TYPES.DONE:
            return { ...state, loading: false };

        case ACTION_TYPES.GET_INVENTORY_DEVICES:
            return { ...state, deviceCatalog: action.data };

        case ACTION_TYPES.ADD_INVENTORY_DEVICE:
            return { ...state, deviceCatalog: [...state.deviceCatalog, action.data] };

        case ACTION_TYPES.UPDATE_INVENTORY_DEVICE:
            return {
                ...state,
                deviceCatalog: state.deviceCatalog.map(d =>
                    d._id === action.data._id ? action.data : d
                ),
            };

        case ACTION_TYPES.DELETE_INVENTORY_DEVICE:
            return {
                ...state,
                deviceCatalog: state.deviceCatalog.filter(d => d._id !== action.id),
            };

        case ACTION_TYPES.RESET_INVENTORY_ITEMS:
            return { ...state, inventoryList: [], deviceCatalog: [] };

        default:
            return state;
    }
};
